<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,0C15,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1.55,0.45,2,1,2C1,2,15,2,15,2C15.55,2,16,1.55,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0ZM6,4C6,4,3,4,3,4C2.45,4,2,4.45,2,5C2,5,2,14,2,14C2,14.55,2.45,15,3,15C3,15,6,15,6,15C6.55,15,7,14.55,7,14C7,14,7,5,7,5C7,4.45,6.55,4,6,4C6,4,6,4,6,4ZM13,4C13,4,10,4,10,4C9.45,4,9,4.45,9,5C9,5,9,9,9,9C9,9.55,9.45,10,10,10C10,10,13,10,13,10C13.55,10,14,9.55,14,9C14,9,14,5,14,5C14,4.45,13.55,4,13,4C13,4,13,4,13,4Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'AlignmentTop',
} as DefineComponent
</script>
